import { render, staticRenderFns } from "./AuthFooter.vue?vue&type=template&id=0ebf25ec&scoped=true&"
import script from "./AuthFooter.vue?vue&type=script&lang=js&"
export * from "./AuthFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebf25ec",
  null
  
)

export default component.exports